import { GET_TRANSFERS_RECEIVED, GET_TRANSFERS_REQUESTED, GET_INCOMING_TRANSFERS } from '../actions/transferActions';
var initialState = {
  transfers: [],
  transfersReceived: [],
  fetching: true,
  twoFactorAuth: {
    isAuthenticated: true
  }
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case GET_INCOMING_TRANSFERS:
      return Object.assign({}, state, {
        transfersReceived: payload
      });
    case GET_TRANSFERS_RECEIVED:
      return Object.assign({}, state, {
        transfers: payload,
        fetching: false
      });
    case GET_TRANSFERS_REQUESTED:
      return Object.assign({}, state, {
        fetching: true
      });
    default:
      return state;
  }
}